import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const FlagsContext = createContext({ flags: {}, loading: true, refresh: () => {} });

export function FlagsProvider({ children }) {
    const { user } = useAuth();
    const [flags, setFlags] = useState({});
    const [loading, setLoading] = useState(false);

    const refresh = useCallback(async () => {
        if (!user) {
            setFlags({});
            return;
        }
        setLoading(true);
        try {
            const { data } = await api.get("/flags");
            setFlags(data);
        } catch {
            // ignore
        } finally {
            setLoading(false);
        }
    }, [user]);

    useEffect(() => {
        refresh();
        if (!user) return;
        const id = setInterval(refresh, 30000);
        return () => clearInterval(id);
    }, [refresh, user]);

    return <FlagsContext.Provider value={{ flags, loading, refresh }}>{children}</FlagsContext.Provider>;
}

export const useFlags = () => useContext(FlagsContext);
export const useFeatureFlag = (key) => {
    const { flags } = useFlags();
    return flags[key]?.enabled || false;
};

